import 'angular:locale/data:en-US';
import 'angular:locale/data:nl';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
